/*
 * @Author: 吴文洁
 * @Date: 2020-11-16 20:03:24
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2022-11-02 16:13:27
 * @Description:
 * @Copyright: © 2020 杭州杰竞科技有限公司 版权所有
 */
import objectAssign from 'object-assign';
// import { cityData } from './cityData.js';

const mergeOptions = function ($vm, options) {
  const defaults = {}
  for (let i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default
    }
  }
  const _options = objectAssign({}, defaults, options)
  for (let i in _options) {
    $vm[i] = _options[i]
  }
}
const only = function(obj, keys) {
  obj = obj || {};
  if ("string" == typeof keys) keys = keys.split(/ +/);
  return keys.reduce(function(ret, key) {
    if (null == obj[key]) return ret;
    ret[key] = obj[key];
    return ret;
  }, {});
};
const trim = str => {
  return str.replace(/(\s|\u00A0)+/g, "");
};

const joinAddress = (code) => {
  if (!code) return '';
  const find = function (obj, callback, context) {
    const _callback = context ? callback.bind(context) : callback;
    if (obj instanceof Array) {
      for (let i = 0; i < obj.length; i++) {
        if (_callback(obj[i], i, obj)) {
          return obj[i];
        }
      }
    } else {
      const keys = Object.keys(obj);
      for (let i = 0; i < keys.length; i++) {
        if (_callback(obj[keys[i]], keys[i], obj)) {
          return obj[keys[i]];
        }
      }
    }
  };

  const format = function (data) {
    return data.map((item, index) => {
      const name = find(item, select => typeof select === 'string');
      const result = { value: index, label: name };
      const children = find(item, select => typeof select !== 'string');
      children && (result.children = format(children));
      return result;
    })
  };

  const list = code.split(',');
  if (list[0] == 34) return '外国';
  const addressCodeList = format(window.AREA);
  const province = addressCodeList[list[0]];
  const city = province.children[list[1]];
  const area = city.children ? city.children[list[2]] : '';
  return area ? `${province.label}省${city.label}市${area.label}` : `${province.label}市${city.label}`;
}

const isUndefined = (value) => {
  return value === void 0 || value === null;
}

const shareTemplate = (str, place) => {
  return str.replace(/\{\$(.*?)\}/g, (full, key) => {
    return place[key] || full
  })
}
const shareTemplateV2 = (str, place) => {
  return str.replace(/\{\$(.*?)\}/g, (full, key) => {
    return place[key] || ""
  })
}
const is_android = () => {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return false;
  } else if (/(Android)/i.test(navigator.userAgent)) {
      return true;
  } else {
      return false;
  };
}
export {
  only,
  trim,
  mergeOptions,
  joinAddress,
  isUndefined,
  shareTemplate,
  shareTemplateV2,
  is_android
}



// WEBPACK FOOTER //
// ./src/core/util.js